import React from 'react';
import { PrimaryButton } from '../BasicForm';

export const OffenderResultCard = (props) => (
	<li className="result-data clear-fix">
		<dl className="general-info">
			<dt>name</dt>
			<dd className="body-bold">{props.fullName}&nbsp;//&nbsp;</dd>
			<dt>age</dt>
			<dd className="body-bold">{props.age},&nbsp;</dd>
			<dt>race</dt>
			<dd className="body-bold">{props.race},&nbsp;</dd>
			<dt>sex</dt>
			<dd className="body-bold">{props.gender}</dd>
		</dl>
		<dl className="secondary-info">
			<div>
				<dt>Alias:&nbsp;</dt>
				<dd>{props.alias || "N/A"}</dd>
			</div>
			<div>
				<dt>Inmate ID #:&nbsp;</dt>
				<dd>{props.offenderId}</dd>
			</div>
			<div>
				<dt>Location:&nbsp;</dt>
				<dd>{props.locationName}</dd>
			</div>
			<div>
				<dt>Release Date:&nbsp;</dt>
				<dd>{props.projectedReleaseDate}</dd>
			</div>
		</dl>
		<form>
			<PrimaryButton 
				className="primary-button"
				label="Add"
				handleClick={props.addOffender}
				options={props.offenderId} />
		</form>
	</li>
);


// WEBPACK FOOTER //
// ./src/components/OffenderResultCard/OffenderResultCard.js